var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamSidebarImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Team",
    d: "M11,15H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0h7a4,4,0,0,1,4,4v7A4.005,4.005,0,0,1,11,15ZM6.284,6.7a.966.966,0,0,0-.965.965v2.62a2.483,2.483,0,1,0,4.965,0V7.662A.966.966,0,0,0,9.319,6.7Zm4.2,0a1.521,1.521,0,0,1,.347.966v2.62l0,.174a3,3,0,0,1-.291,1.132,2.209,2.209,0,0,0,2.776-2.133V7.662a.966.966,0,0,0-.966-.965Zm-5.375,0H3.249l-.079,0a.971.971,0,0,0-.887.962V9.455a2.208,2.208,0,0,0,2.777,2.132,3.014,3.014,0,0,1-.293-1.305V7.662l0-.121A1.506,1.506,0,0,1,5.114,6.7Zm6.272-3.309a1.379,1.379,0,1,0,1.379,1.379A1.381,1.381,0,0,0,11.386,3.387ZM7.8,2.835A1.655,1.655,0,1,0,9.455,4.49,1.657,1.657,0,0,0,7.8,2.835Zm-3.586.552A1.379,1.379,0,1,0,5.594,4.766,1.381,1.381,0,0,0,4.215,3.387Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamSidebarImage);
export default __webpack_public_path__ + "static/media/Team-sidebar-image.b9668ea5e8900c76d0e9d870cefbe219.svg";
export { ForwardRef as ReactComponent };